import MuiTooltip, {
  // eslint-disable-next-line import/named
  TooltipProps as MuiTooltipProps,
} from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import ReadMoreIcon from "@mui/icons-material/ReadMore";

export interface TooltipProps extends Omit<MuiTooltipProps, "title"> {
  componentName: string;
  tooltipMessage: string;
  readMoreLink?: string;
}

export const Tooltip = ({
  componentName,
  tooltipMessage,
  readMoreLink,
  children,
  ...props
}: TooltipProps) => {
  return (
    <MuiTooltip
      {...props}
      data-testid={`${componentName}-tooltip`}
      arrow
      title={
        <Box
          flexDirection="row"
          display="flex"
          justifyContent="center"
          alignItems="center"
          columnGap={1}
        >
          <Typography variant="body2">{tooltipMessage}</Typography>
          {readMoreLink && (
            <Link
              href={readMoreLink}
              target="_blank"
              rel="noopener"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <ReadMoreIcon sx={{ color: "#007BFF" }} />
            </Link>
          )}
        </Box>
      }
    >
      {children}
    </MuiTooltip>
  );
};
